/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description monetizedSimilarListings whitelist
 */

import { CLEAR_ENTITY } from '../../entity/constants/index'
import * as constants from '../constants'
import type { Actions } from './meta'

// This satisfies makes sure that everything in the whitelist is also used in the reducer
export const whitelist = [
  CLEAR_ENTITY,
  ...Object.values(constants),
] as const satisfies ReadonlyArray<Actions['type']>

// These 2 lines make sure that every action type that the reducer uses is included in the whitelist
declare const shouldBeEmpty: Exclude<Actions['type'], (typeof whitelist)[number]>
false && (shouldBeEmpty satisfies never)
